import { styled, InputBase} from "@mui/material";

const MySelect = styled(InputBase)(({ theme }) => ({
    '& label': {
        backgroundColor: "#fff",
    },
    '& .MuiInputBase-input': {
        borderRadius: 4,
        position: 'relative',
        backgroundColor: "#fff",
        border: `1px solid rgba(166,178,205,.25)`,
        fontSize: 16,
        padding: '6px 26px 6px 12px',
        color: "#25313C",
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
    '& .MuiSvgIcon-root' :{
        color: "#25313C"
    },
    '& .MuiInputLabel-formControl':{
        backgroundColor: "#fff",
    }
}));
export default MySelect

export const MySelect2  = styled(InputBase)(({ theme, padding}) => ({
    '& label': {
        backgroundColor: "#fff",
    },
    '& .MuiInputBase-input': {
        borderRadius: 4,
        position: 'relative',
        backgroundColor: "#fff",
        border: `1px solid #ced4da`,
        fontFamily: "Poppins-Regular",
        fontSize: '0.8em',
        padding: padding ? padding : '7px 26px 7px 12px',
        color: "#25313C",
    },
    '& .MuiSvgIcon-root' :{
        color: "#ced4da"
    },
    '& .MuiInputLabel-formControl':{
        backgroundColor: "#fff",
    }
}));

export const MySelect3  = styled(InputBase)(({ theme }) => ({
    '& label': {
        backgroundColor: "#fff",
    },
    '& .MuiInputBase-input': {
        borderRadius: 4,
        position: 'relative',
        border: `1px solid #E5E5E5`,
        fontFamily: "Poppins-Regular",
        fontSize: '0.8em',
        padding: '7.5px 10px 7.5px 10px!important',
        color: "#25313C",
    },
    '& .MuiSvgIcon-root' :{
        color: "#ced4da"
    },
    '& .MuiInputLabel-formControl':{
        backgroundColor: "#fff",
    }
}));
export const MySelectGrey  = styled(InputBase)(({ theme }) => ({
    '& label': {
        backgroundColor: "#E5E5E5",
    },
    '& .MuiInputBase-input': {
        borderRadius: 4,
        position: 'relative',
        border: `1px solid #E5E5E5`,
        fontFamily: "Poppins-Regular",
        fontSize: '0.8em',
        padding: '10px!important',
        color: "#25313C",
        backgroundColor: "#E5E5E5",
    },
    '& .MuiSvgIcon-root' :{
        color: "#ced4da"
    },
    '& .MuiInputLabel-formControl':{
        backgroundColor: "#fff",
    }
}));
